import { render, staticRenderFns } from "./MenuToolbar.vue?vue&type=template&id=438b7073&scoped=true"
import script from "./MenuToolbar.vue?vue&type=script&lang=js"
export * from "./MenuToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438b7073",
  null
  
)

export default component.exports